import { LoginFormInputs } from "./LoginForm.types";
import { apiService, Endpoints } from "api";

export const signInRequest = async ({ email, password }: LoginFormInputs) => {
  const { data } = await apiService.post(Endpoints.Auth.Post.LogIn, {
    email: email.toLowerCase(),
    password,
  });

  return data;
};

type SsoLookupResult = { provider?: string; companyId?: number };

export const ssoLookupRequest = async (
  email: string,
): Promise<SsoLookupResult> => {
  const { data } = await apiService.get<SsoLookupResult>(
    Endpoints.Auth.Get.SsoLookup(email.toLowerCase()),
  );
  return data;
};
